import { Edit } from 'react-admin';
import { AccordionForm } from '@react-admin/ra-form-layout';
import { ReactElement } from 'react';
import { BidResource } from '../../Entities/Bid';
import EditToolbar from '../../Components/EditToolbar';
import ApprovalDetailsSection from './Form/Edit/ApprovalDetailsSection';
import BidStatusSection from './Form/BidStatusSection';
import OfferDetailsSection from './Form/Edit/OfferDetailsSection';
import GetPriceDetailsSection from './Form/GetPriceDetailsSection';

export default function BidEdit(): ReactElement {
  return (
    <Edit<BidResource>
      mutationMode="pessimistic"
      queryOptions={{ meta: { prefetch: ['merchant', 'category', 'product'] } }}
    >
      <AccordionForm toolbar={<EditToolbar />}>
        <ApprovalDetailsSection label="Approval status/details" />
        <BidStatusSection label="Bid status" />
        <OfferDetailsSection label="Offer details" />
        <GetPriceDetailsSection label="GetPrice details" />
      </AccordionForm>
    </Edit>
  );
}
